import React from 'react'

import { Box, Skeleton } from '@mui/material'

// Fixed chart height used by the blueprint detail page's trend area. Keep in
// sync with the real chart footprint so swapping the chart in never shifts the
// layout.
const CHART_HEIGHT = 187

/**
 * Loading placeholder for the monthly trend bars on the blueprint detail
 * page. Reserves the chart's fixed footprint (12 bars + an x-axis label line
 * inside `CHART_HEIGHT`).
 */
export const MonthlyTrendBarChartSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: CHART_HEIGHT }} aria-busy="true">
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, flex: 1, minHeight: 0, px: 0.5 }}>
      {Array.from({ length: 12 }, (_, i) => (
        <Skeleton key={i} variant="rounded" sx={{ flex: 1, height: `${30 + ((i * 37) % 60)}%` }} />
      ))}
    </Box>
    {/* X-axis tick labels row */}
    <Skeleton variant="text" width="40%" sx={{ fontSize: '0.75rem', mt: 0.5 }} />
  </Box>
)
